<template>
    <div itemscope itemtype="http://schema.org/Article" class="inner-article-page" style="padding: 0 0;">
        <div class="sub-container">
            <!--            <div class="breadcrumbs">-->
            <!--                <ul>-->
            <!--                    <li><a :href="$store.state.hrefPrefix + '/'">{{ $t('home') }}</a></li>-->
            <!--                    <li><img src="/assets/images/pagination-right.svg" alt=""/></li>-->
            <!--                    <li><a :href="$store.state.hrefPrefix + '/category/' + article.category.slug">{{-->
            <!--                            article.category.category_languages[0].pivot.name-->
            <!--                        }}</a></li>-->
            <!--                    <li><img src="/assets/images/pagination-right.svg" alt=""/></li>-->
            <!--                    <li>{{ article.article_languages[0].pivot.title }}</li>-->
            <!--                </ul>-->
            <!--            </div>-->

            <div class="inner-article-top">
                <h1 itemprop="name" :class="{'arabic-font': $store.state.language.code === 'ar'}">
                    {{ article.article_languages[0].pivot.title }}</h1>
                <p :class="{'arabic-font': $store.state.language.code === 'ar'}">
                    {{ article.article_languages[0].pivot.description }}</p>
                <div class="another-name">
                    <template v-if="!isDebate">
                        <i v-if="article.author.blob != null"><img :src="article.author.blob.url" alt=""/></i>
                        <p itemprop="author" itemscope itemtype="http://schema.org/Person">
                            <a :href="$store.state.hrefPrefix + '/authors/' + article.author.slug"
                               style="color: #A40404" itemprop="name">
                                {{ article.author.author_languages[0].pivot.name }}
                            </a>
                        </p>

                        <template v-if="article.second_author != null">
                            <i style="margin-left: 16px" v-if="article.second_author.blob != null"><img
                                :src="article.second_author.blob.url" alt=""/></i>
                            <p>
                                <a :href="$store.state.hrefPrefix + '/authors/' + article.second_author.slug"
                                   style="color: #A40404">
                                    {{ article.second_author.author_languages[0].pivot.name }}
                                </a>
                            </p>
                        </template>
                    </template>
                    <p v-else>
                        <a :href="$store.state.hrefPrefix + '/category/' + article.category.slug"
                           style="color: #A40404">
                            {{ article.category.category_languages[0].pivot.name }}
                        </a>
                    </p>
                </div>
                <div class="another-name" style="margin-top: 16px">
                    <p>
                        <span itemprop="datePublished" :content="article.published_at ?? article.created_at"
                              style="color: #54585E">{{ formatDate(article.published_at ?? article.created_at) }}</span>
                    </p>
                </div>
            </div>
            <div class="inner-article-img">
                <img itemprop="image" v-if="article.blob" :src="article.blob.url" alt="">
                <span v-if="article.article_languages[0].pivot.image_caption != null">{{
                        article.article_languages[0].pivot.image_caption
                    }}</span>
            </div>
            <!--            <div class="audio-player">-->

            <!--                <div class="controls">-->
            <!--                    <div class="play-container">-->
            <!--                        <div class="toggle-play play">-->
            <!--                            <img src="/assets/images/play-icon.svg"/>-->
            <!--                            <img src="/assets/images/audio-pause-icon.svg"/>-->
            <!--                        </div>-->
            <!--                    </div>-->
            <!--                    <div class="time">-->
            <!--                        <div class="current">0:00</div>-->
            <!--                    </div>-->
            <!--                    <div class="timeline">-->
            <!--                        <div class="progress"></div>-->
            <!--                    </div>-->
            <!--                    <div class="time">-->
            <!--                        <div class="length"></div>-->
            <!--                    </div>-->

            <!--                    <div class="volume-container">-->
            <!--                        <div class="volume-button">-->
            <!--                            <div class="volume icono-volumeMedium">-->
            <!--                                <img src="/assets/images/volume-icon.svg"/>-->
            <!--                            </div>-->
            <!--                        </div>-->

            <!--                        <div class="volume-slider">-->
            <!--                            <div class="volume-percentage"></div>-->
            <!--                        </div>-->
            <!--                    </div>-->


            <!--                </div>-->
            <!--                &lt;!&ndash; <audio controls>-->
            <!--                    <source src="/assets/audio.ogg" type="audio/ogg">-->
            <!--                    <source src="/assets/audio.mp3" type="audio/mpeg">-->
            <!--                    Your browser does not support the audio element.-->
            <!--                </audio> &ndash;&gt;-->
            <!--            </div>-->
            <div class="inner-article-content">
                <div v-if="isDebate" class="row" style="margin-bottom: 40px">
                    <span :class="{'arabic-content-font': $store.state.language.code === 'ar'}"
                          v-html="article.article_languages[0].pivot.body_text"></span>
                </div>
                <div class="row">
                    <div class="col-md-8 col-sm-7">
                        <div class="article-content"
                             :class="{'arabic-content-font': $store.state.language.code === 'ar'}">
                            <!--                            <div class="article-content-box">-->
                            <!--                                <p>The high-level delegation, which includes several government officials, has indefinitely extended its stay in Washington for the “difficult” negotiations, indicating Iraq’s limited options in these talks. If the discussions-->
                            <!--                                    fail and Washington does not ease its punishing measures, a major crisis could erupt in Iraq – resulting in the collapse of the dinar’s value because of high demand and limited supply.</p>-->
                            <!--                            </div>-->
                            <span v-if="!isDebate" v-html="article.article_languages[0].pivot.body_text"
                                  itemprop="articleBody" class="article-body">

                            </span>
                            <div v-else-if="selectedDebate != null" style="margin-bottom: 40px">
                                <div style="background-color: rgb(244, 244, 244);padding: 20px" class="columns-row">
                                    <div class="columns_img img-scale-in">
                                        <a>
                                            <img v-if="selectedDebate.author.blob != null" style="width: 80px"
                                                 :src="selectedDebate.author.blob.url" alt=""/>
                                        </a>
                                    </div>
                                    <div class="columns_content" :class="{'lower-opacity': !selected}">
                                        <h2>
                                            <a>
                                                <b>{{ selectedDebate.author.author_languages[0].pivot.name }}</b>
                                            </a>
                                        </h2>
                                        <p style="color: black; font-size: 14px; line-height: 1.1rem">
                                            {{ selectedDebate.author.author_languages[0].pivot.bio }}</p>
                                    </div>
                                </div>
                                <h2 style="margin-bottom: 40px"
                                    v-html="selectedDebate.debate_languages[0].pivot.title"></h2>
                                <span v-html="selectedDebate.debate_languages[0].pivot.body_text"></span>
                            </div>
                        </div>
                        <div v-if="$store.state.language.code === 'ar'" style="width: 100%; text-align: center;margin-top: 20px; margin-bottom: 20px;">
                            <a style="width: 100%; text-align: center; display: block;  border: 2px solid rgb(25, 25, 25); padding: 10px; border-radius: 5px; color: rgb(25, 25, 25)"
                               href="https://news.google.com/publications/CAAqMAgKIipDQklTR1FnTWFoVUtFM1JvWldOeVlXUnNaV0Z5WVdKcFl5NWpiMjBvQUFQAQ?hl=ar&gl=SA&ceid=SA%3Aar">
                                <span>تابعوا آخر أخبار ومقالات The Cradle العربي عبر Google News</span>
                                <img src="/assets/images/google_news_logo.webp" alt="Google News"
                                     style="width: 30px; margin-right: 10px;margin-left: 10px">
                            </a>
                        </div>

                        <span class="necessarily" v-if="article.category.slug !== 'news'"> {{
                                $t('the_views_expressed_in_this_article_do_not_necessarily_reflect_those_of_the_cradle')
                            }}</span>
                        <ul class="article-tag">
                            <li v-for="keyword in keywords"><a href="#">{{
                                    keyword.keyword_languages[0].pivot.name
                                }}</a></li>
                        </ul>

                        <div class="article-Comments" id="comments">
                            <div class="article-Comments-top">

                                <p>{{ comments.length }} {{ $t('comments') }} </p>
                                <div class="Comments-sort">
                                    <span>{{ $t('sort_by') }} </span>
                                    <select dir="ltr">
                                        <option>{{ $t('newest') }}</option>
                                    </select>
                                </div>
                            </div>
                            <form :action="$store.state.hrefPrefix + '/articles/' + article.id + '/comment'"
                                  method="post" ref="comment">
                                <input type="hidden" name="_token" :value="csrf">
                                <div class="comments-text">
                                    <textarea :placeholder="$t('Write your comment')" id="comment"
                                              name="comment"></textarea>
                                </div>
                                <div class="Comments-btn">
                                    <a :href="$store.state.hrefPrefix + '/account/login'"
                                       v-if="$store.state.user.id == null">
                                        <button type="button">{{ $t('cap_log_in_to_comment') }}</button>
                                    </a>
                                    <template v-else>
                                        <button class="g-recaptcha"
                                                data-sitekey="6Ld3Xv8mAAAAAJSdwXb6BysaOps8-vQJMk9W_ej5"
                                                data-callback="submitComment">{{ $t('cap_post_comment') }}
                                        </button>

                                    </template>
                                </div>
                            </form>

                            <div v-if="errors.length > 0"
                                 style="background-color: rgba(255,116,116,0.56); border: #ff0e00 solid 2px; padding: 8px">
                                <ul style="padding: revert; margin: revert">
                                    <li style="list-style: square" v-for="error in errors"> {{ error }}</li>
                                </ul>
                            </div>
                            <div v-if="successes.length > 0"
                                 style="background-color: rgba(141,255,116,0.56); border: #00ff04 solid 2px; padding: 8px">
                                <ul style="padding: revert; margin: revert">
                                    <li style="list-style: square" v-for="success in successes"> {{ success }}</li>
                                </ul>
                            </div>
                            <div v-for="comment in comments.data" class="user-comments">
                                <div class="user-img">
                                    <i><img src="/assets/images/user-img.svg" alt=""/></i>
                                    <p>{{ comment.user.name }} <span>{{ formatDateTime(comment.created_at) }}</span></p>
                                </div>
                                <div class="comments">
                                    <p v-text="comment.text"></p>
                                </div>
                                <div class="comments-reply">
                                    <!--                                    <div class="react-left">-->
                                    <!--                                        <span class="comments-like">0</span>-->
                                    <!--                                        <span class="Reply"><img src="/assets/images/reply-icon.svg"-->
                                    <!--                                                                 alt=""/>Reply</span>-->
                                    <!--                                        <div class="comments-react">-->
                                    <!--                                            <p><i><img src="/assets/images/plus-icon.svg" alt=""/></i> React</p>-->
                                    <!--                                            <span>1 <img src="/assets/images/Laughing.svg" alt=""/></span>-->
                                    <!--                                            <span>2 <img src="/assets/images/Angry.svg" alt=""/></span>-->
                                    <!--                                            <span>4 <img src="/assets/images/Soaked.svg" alt=""/></span>-->
                                    <!--                                        </div>-->
                                    <!--                                    </div>-->
                                    <span class="report"><img src="/assets/images/report-icon.svg"
                                                              alt=""/>{{ $t('report') }} </span>
                                </div>
                            </div>

                        </div>

                    </div>
                    <div class="col-md-4 col-sm-5">
                        <div v-if="isDebate" class="columns-box web-view" style="margin-bottom: 20px">
                            <h2 class="heading"><a href="#">{{ $t('debaters') }} </a></h2>
                            <div class="columns-section">
                                <debaters-article-selectable v-for="debate in article.debates"
                                                             @click="debateSelected(debate)"
                                                             :debate="debate" :article="article"
                                                             :selected="selectedDebate != null && selectedDebate.id === debate.id"></debaters-article-selectable>
                            </div>
                        </div>
                        <div class="col-md-12 col-sm-12" v-if="$store.state.language.code !== 'ar'">
                            <div class="columns-box web-view-poll" v-if="poll !== '' && poll != null">
                                <h2 class="heading" style="background-image: none;"><a>Poll</a></h2>
                                <div class="columns-section">
                                    <div class="columns-row">
                                        <poll :poll="poll"></poll>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <most-popular :articles="mostPopularArticles"></most-popular>
                    </div>

                </div>
            </div>
        </div>
    </div>

</template>

<script>
import DebatersArticle from "@/parts/Columns/DebatersArticle.vue";

let errors = [];
if (typeof pageErrors !== 'undefined') {
    errors = pageErrors;
}

let successes = [];
if (typeof pageSuccesses !== 'undefined') {
    successes = pageSuccesses;
}
import MostPopular from "@/parts/home/MostPopular.vue";
import DebatersArticleSelectable from "@/parts/Columns/DebatersArticleSelectable.vue";
import SupportPopup from "@/parts/home/TopBar/SupportPopup.vue";
import ColumnArticle from "@/parts/Columns/ColumnArticle.vue";
import Poll from "@/parts/Poll.vue";

export default {
    name: "ArticlePage",
    components: {Poll, ColumnArticle, SupportPopup, DebatersArticleSelectable, DebatersArticle, MostPopular},
    data: () => {
        return {
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            googleCaptchaToken: null,
            errors: errors,
            successes: successes,
            selectedDebate: null,
            isShow: false
        }
    },
    created() {
        window.addEventListener('scroll', this.handleScroll);

    },
    methods: {
        handleScroll() {
            if(this.$store.state.language.code === 'tr') {
                return;
            }
            const height = document.documentElement,
                bodyScroll = document.body,
                scrollTop = 'scrollTop',
                scrollHeight = 'scrollHeight';
            const scrollPercentage = (height[scrollTop] || bodyScroll[scrollTop]) / ((height[scrollHeight] || bodyScroll[scrollHeight]) - height.clientHeight) * 100;
            // console.log(scrollPercentage)
            if (scrollPercentage > 50) {
                if (!localStorage.getItem('supportUsShown')) {
                    this.showSupportPopup();
                }

            }

        },
        showSupportPopup() {
            window.jQuery("#donate-now").addClass("active");
            window.jQuery("html, body").addClass("filter_body");
            localStorage.setItem('supportUsShown', '1')
            // console.log('popupshiown')
        },
        formatDate(dateToFormat) {
            const date = new Date(dateToFormat.replace(' ', 'T'));
            const options = { month: 'short', day: 'numeric', year: 'numeric' };
            let locale = 'en-US';
            switch (this.$store.state.language.code) {
                case 'ar':
                    locale = 'ar-LB';
                    break;
                case 'tr':
                    locale = 'tr-TR';
                    break;
            }
            return date.toLocaleDateString(locale, options).toUpperCase();
        },
        formatDateTime(dateToFormat) {
            const date = new Date(dateToFormat.replace(' ', 'T'));
            const options = {month: 'short', day: 'numeric', year: 'numeric', hour: "2-digit", minute: "2-digit"};
            let locale = 'en-US';
            switch (this.$store.state.language.code) {
                case 'ar':
                    locale = 'ar-LB';
                    break;
                case 'tr':
                    locale = 'tr-TR';
                    break;
            }
            return date.toLocaleDateString(locale, options).toUpperCase();
        },
        submitComment(response) {
            // console.log(response)
            const form = this.$refs.comment;
            form.submit();
        },
        debateSelected(debate) {
            //Change debate param without reloading
            const params = new URLSearchParams(window.location.search);
            params.set('debate', debate.author_id);
            window.history.replaceState({}, '', `${location.pathname}?${params}`);
            this.selectedDebate = debate;
            this.$forceUpdate();
        }
    },
    props: {
        poll: {
            default: null
        },

        article: {
            type: Object
        },
        mostPopularArticles: {
            type: Array
        },
        comments: {
            type: Object
        },
        keywords: {
            type: Array
        },
        authorArticles: {
            type: Array
        },
    },
    computed: {
        isDebate() {
            return this.article.category.slug === 'debates';
        },
    },
    mounted() {
        window.submitComment = this.submitComment;
        const params = new URLSearchParams(window.location.search);
        const debateQuery = params.get('debate');
        let debate = this.article.debates.find(debate => debate.author_id == debateQuery);
        if (debate == null) {
            this.selectedDebate = this.article.debates[0] || null;
        } else {
            this.selectedDebate = debate;

        }


    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll)
    }
}
</script>

<style>
img {
    max-width: 100%;
}
</style>

<style>

.article-content span ul li {
    margin-bottom: 20px;
}

.inner-article-content .article-content blockquote {
    position: relative;
    padding: 6rem 0 0;
    font-weight: 700;
    color: #5C5C5C;
    margin-top: 0;
    margin-bottom: 0;
}

.web-view-poll {
    display: block;
}

@media (max-width: 960px) {
    .web-view-poll {
        display: block !important;
    }
}

@media (max-width: 767px) {
    .web-view-poll {
        display: block !important;
    }
}

/* set list style to revert for ul and ol in .article-body */
.article-body ul, .article-body ol {
    list-style: revert;
    margin: revert;
    padding: revert;
}

.article-body ul li, .article-body ol li {
    margin-bottom: revert;
}
</style>
